var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.menu)?_c('div',[(_vm.menu.contents)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.menu.contents.htmlValue)}}):_vm._e(),(_vm.menu.contents)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.menu.contents.cssValue)}}):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }